import styled from 'styled-components';
import {
  TableRow,
  Image,
  IconCheckAltActive,
  Banner,
  TextLink,
} from '@spotify-internal/encore-creator-web';
import { white, gray95, spacer12, spacer32 } from '@spotify-internal/encore-foundation';

export const EpisodeResultsBanner = styled(Banner)`
  margin-top: ${spacer32};
`;

export const EpisodeResultsLink = styled(TextLink)`
  text-decoration: underline;
`;

export const EpisodeRow = styled(TableRow)<{ active: boolean }>`
  background-color: ${props => (props.active ? gray95 : white)};
  cursor: pointer;
`;

export const PodcastThumbnail = styled.div`
  display: flex;
  align-items: center;
`;

export const PodcastImageWrapper = styled.div`
  position: relative;
`;

export const PodcastImage = styled(Image).attrs<{
  src: string;
  alt: string;
}>(props => ({
  src: props.src,
  alt: props.alt,
  imageHeight: '48px',
  imageWidth: '48px',
  crop: true,
}))`
  margin-right: ${spacer12};
`;

const THUMBNAIL_DIMENSIONS = 48;
const CHECKMARK_DIMENSIONS = 24;
const pos = THUMBNAIL_DIMENSIONS / 2 - CHECKMARK_DIMENSIONS / 2;
export const Checkmark = styled(IconCheckAltActive)`
  filter: drop-shadow(0 4px 3px);
  transform: translate(${pos}px, ${pos}px);
`;
